import React, { Component } from 'react';
import './index.less';

class index extends Component {
    state = {
        list: [
            {
                name: '大五人格测验精简版',
                desc: '测评时长15分钟，共60题',
                content: `
                <p>
                根据普遍公认的“Big Five”大五人格模型，结合国内文化背景开发而成，深入分析受测者的性格特点以及优劣势
                </p><p>
                测评维度：心理健康、外倾性、开放性、宜人性和责任心。
                </p>
                `,
                report: '//j1.58cdn.com.cn/arthurupload/hrg/fe/campus/1.pdf'
            },
            {
                name: '认知能力测验精简版',
                desc: '测评时长40分钟，共40题',
                content: `<p>测量个体所具备的一般能力倾向或潜在能力对受测者未来的工作能力和效率有良好的预测作用
                </p><p>
                测评维度：言语理解与表达能力、逻辑推理能力、数学运算能力。 </p>`,
                report: '//j1.58cdn.com.cn/arthurupload/hrg/fe/campus/2.pdf'
            },
            {
                name: '职业行为风险测验',
                desc: '测评时长30分钟，共164题',
                content: `<p>从外部聘用可能带来的心理健康隐患入手，挖掘受测者可能存在的行为风险，主要应用于招聘选拔鞠策，降低企业的雇佣风险。
                </p><p>
                测评维度：冲动违规，情绪无常，特立独行，偏执多疑等。 </p>`,
                report: '//j1.58cdn.com.cn/arthurupload/hrg/fe/campus/3.pdf'
            },
            {
                name: '职业胜任力测验',
                desc: '测评时长30分钟，共130题',
                content: `<p>胜任力是指能将工作中的绩优者与普通者区分开来的个人深层特征，测评结果可解释受测者与目标岗位的匹配度与潜力。
                </p><p>
                测评维度：自主力，思考力，执行力，人际力，团队力，领导力。</p>`,
                report: '//j1.58cdn.com.cn/arthurupload/hrg/fe/campus/4.pdf'
            },
            {
                name: 'MBTI职业个性测评',
                desc: '测评时长25分钟，共94题',
                content: `<p>该测试测量受测者与生俱来的个性类型，帮助人们了解受测者个性上的优势和劣势。测试结果可被广泛运用在职位定位、领导力发展、团队建设等领域。
                </p><p>
                测评维度：外向/内向、感觉/直觉、思考/情感、判断/知觉</p>`,
                report: '//j1.58cdn.com.cn/arthurupload/hrg/fe/campus/5.pdf'
            }
        ]
    }
    render() {
        let me = this;
        let {
            list
        } = me.state;
        return (
            <div className="price">
                {
                    list.map(({ name, desc, content, report }, i) => {
                        return (
                            <div className="price_item" key={i}>
                                <div className={`price_header bg_${i + 1}`}>
                                    <div className="name">
                                        {name}
                                    </div>
                                </div>
                                <div className="price_body">
                                    <div className="text">
                                        {desc}
                                    </div>
                                    <div className="content" dangerouslySetInnerHTML={{ __html: content }}>
                                    </div>
                                </div>
                                {/* <div className="price_footer">
                                    <a target="_blank" href={report} className="sample-btn">
                                        查看报告样例
                                    </a>
                                </div> */}
                            </div>
                        );
                    })
                }
            </div>
        );
    }
}

export default index;